export default "__VITE_ASSET__Sax7bQMX__"